<template>
  <transition name="fade-in">
    <transition v-if="isShow && !isMobile" name="slide-fade">
      <div
        class="
          flex flex-col
          justify-center
          bg-white
          text-13
          w-96
          h-48
          drop-shadow
          shadow-black
          text-primary-100
          p-3
          fixed
          top-0
          left-1/2
          transform
          -translate-x-1/2
          translate-y-4
          z-150
        "
      >
        <div class="flex items-center h-auto mt-1">
          <div class="p-2 border mr-3">
            <OIcon icon="o-logo" svg-class="w-9 h-9" />
          </div>
          <div>
            <div class="font-semibold text-md">{{ $t('push-alert.title') }}</div>
            <div>{{ $t('push-alert.description') }}</div>
          </div>
        </div>
        <div class="flex mt-4 justify-end">
          <OButton
            pure
            class="px-3 py-1 text-primary-100 border border-black-50 rounded-none mr-2 hover:bg-black-10"
            @click="handleGranted(false)"
          >
            {{ $t('push-alert.deny-button') }}
          </OButton>
          <OButton
            pure
            class="px-7 py-1 bg-green-500 text-white border-green-400 border rounded-none font-semibold hover:bg-green-700"
            @click="handleGranted()"
          >
            {{ $t('push-alert.access-button') }}
          </OButton>
        </div>
      </div>
    </transition>
    <div v-else-if="isShow && isMobile" class="bg-black-60 fixed z-140 w-full h-full top-0 left-0 right-0 bottom-0">
      <div
        class="top-[41%] absolute p-3 w-11/12 h-30 text-black rounded-lg bg-white left-1/2 transform -translate-x-1/2 translate-y-4 z-150"
      >
        <div class="flex items-center text-primary-100">
          <IconBell width="32px" height="40px" class="text-blue-500" />
          <div>{{ $t('push-alert.mobile-title') }}</div>
        </div>
        <div class="ml-auto flex justify-end gap-9 text-blue-500 mt-2">
          <OButton pure @click="handleGranted(false)">{{ $t('push-alert.deny-button') }}</OButton>
          <OButton pure @click="handleGranted()">{{ $t('push-alert.access-button') }}</OButton>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { defineComponent, ref, onMounted, useContext, onBeforeUnmount } from '@nuxtjs/composition-api';
import { OButton, OImage, OIcon } from '~/modules/common/components/ui';
import { eventBus } from '~/modules/common/utils/eventBus';
import { useDevice } from '~/composables/useDevice';
import IconBell from '~/static/images/bell.svg?inline';

export default defineComponent({
  components: { OImage, OButton, OIcon, IconBell },
  setup() {
    const isShow = ref(false);
    const { isMobile } = useDevice();
    const { $analyticsEvent } = useContext();
    const handleShowAlert = () => {
      setTimeout(() => {
        isShow.value = !isShow.value;
      }, 15000);
    };

    const handleGranted = (result = true) => {
      $analyticsEvent('User', 'User_Engagement', `action_pushalert_${result ? 'subscribe' : 'notnow'}`);
      eventBus.emit('set-granted', { success: result });
      isShow.value = false;
    };

    onMounted(() => {
      eventBus.on('webpush-alert', handleShowAlert);
    });

    onBeforeUnmount(() => {
      eventBus.off('webpush-alert', handleShowAlert);
    });

    return { isShow, isMobile, handleGranted };
  },
});
</script>

<style lang="scss">
.slide-fade-enter-active {
  transform-origin: top;
  transition: all 1s ease;
}

.slide-fade-enter,
.slide-fade-leave-to {
  transform: translate(-50%, -400px);
}
</style>
